module.exports = __webpack_public_path__ + "img/x4.c002a37c.jpg";